import React from 'react';

const TourGallerySection = () => {
  return (
    <section className="best-section">
      <div className="container">
        <div className="row">
          {/* Left Section: Heading and Feature Image */}
          <div className="col-lg-5">
            <div className="section-heading">
              <h5 className="dash-style">OUR FLEET & SERVICES</h5>
              <h2>RELIABLE RIDES WITH PRINCE CABS</h2>
              <p>
                Prince Cabs offers a premium fleet and professional drivers to ensure a safe, comfortable, and timely journey 
                for every customer. Whether it’s daily commuting, airport transfers, or outstation trips, experience service you can trust.
              </p>
            </div>
            <figure className="gallery-img">
              <img src="/images/img12.jpg" alt="Prince Cabs Fleet" />
            </figure>
          </div>

          {/* Right Section: Gallery Images */}
          <div className="col-lg-7">
            <div className="row">
              <div className="col-sm-6">
                <figure className="gallery-img">
                  <img src="/images/matheran.webp" alt="Prince Cabs Service 1" />
                </figure>
              </div>
              <div className="col-sm-6">
                <figure className="gallery-img">
                  <img src="/images/lonavala.webp" alt="Prince Cabs Service 2" />
                </figure>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <figure className="gallery-img">
                  <img src="/images/MAHABALESHWAR.jpg" alt="Prince Cabs Service 3" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourGallerySection;
